import { Nav } from 'react-bootstrap'
import { NavItemWrapper, NavWrapper } from './styles'

interface IProps {
    activeKey: string,
    centerId: number,
    isAdmin: boolean
}

const PwlNav = (props: IProps) => {
    const tabWidth = 200;
    const hrefPrefix = props.isAdmin ? '/admin/reports/dash-board' : `/center/${props.centerId}/reports/dash-board`;
    
    return (
        <NavWrapper>
            <div style={{ backgroundColor: 'white' }}>
                <Nav bsStyle='pills' className='ms-pills'>
                    <NavItemWrapper active={props.activeKey == 'LAB-BILLING'} href={`${hrefPrefix}/pwl-labbilling`} tabWidth={tabWidth}>
                        Lab Billing
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'JUG-BILLING'} href={`${hrefPrefix}/pwl-jugbilling`} tabWidth={tabWidth}>
                        Jug Billing
                    </NavItemWrapper>
                </Nav>
            </div>
        </NavWrapper>
    );
}

export default PwlNav;